import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2046aab4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2046aab4')) {
      api.createRecord('2046aab4', component.options)
    } else {
      api.reload('2046aab4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2046aab4", function () {
      api.rerender('2046aab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/index.vue"
export default component.exports